// src/app/theme/localThemePreferenceStore.ts
import type { IThemeEnginePreferenceStore } from '@vanialabs/ui-engine';

/**
 * localThemePreferenceStore
 * ------------------------
 * Thin localStorage adapter satisfying ThemeEngine's
 * `IThemeEnginePreferenceStore` port. Mirrors the app's existing
 * local-storage-backed provider pattern (see localAuthProvider's doc
 * comment referenced from AppRouter): synchronous reads/writes,
 * namespaced key, and failures are swallowed rather than thrown —
 * private browsing / storage-disabled contexts should degrade to a
 * session-only theme selection, not break the app.
 */
const STORAGE_KEY = 'vania.super-admin.theme-preference';

export class LocalThemePreferenceStore implements IThemeEnginePreferenceStore {
  getPreferredThemeId(): string | null {
    try {
      return window.localStorage.getItem(STORAGE_KEY);
    } catch {
      return null;
    }
  }

  setPreferredThemeId(id: string): void {
    try {
      window.localStorage.setItem(STORAGE_KEY, id);
    } catch {
      // Storage unavailable — the selection still applies for this
      // session via in-memory ThemeState, it just won't persist.
    }
  }
}

export const localThemePreferenceStore = new LocalThemePreferenceStore();
